import StorySource from '../../data/story-source';
import LocalStorage from '../../data/local-storage';
import AuthService from '../../services/auth-service';
import BookmarkService from '../../services/bookmark-service';
import {
  getLocationName as fetchLocationName,
  getMapStyleUrl
} from '../../services/location-service';

export default class PostModel {
  constructor() {
    this.isAuthenticated = false;
    this.user = {};
    this.bookmarks = [];
    this.story = null;
    this.currentMapLayer = 'streets';
  }

  loadUserState() {
    const { isAuthenticated, user } = AuthService;
    this.isAuthenticated = isAuthenticated;
    this.user = user || {};
    this.bookmarks = BookmarkService.getBookmarks();

    if (isAuthenticated && user.id) {
      this.currentMapLayer = LocalStorage.getOrSetUserSpecificItem(
        'heliaedu_user_map_layer',
        user.id,
        'streets'
      );
    } else {
      this.currentMapLayer = LocalStorage.getOrSetItem('heliaedu_guest_map_layer', 'streets');
      this.bookmarks = [];
    }
  }

  getMapLayerKey() {
    return this.isAuthenticated && this.user.id
      ? LocalStorage.getUserSpecificKey('heliaedu_user_map_layer', this.user.id)
      : 'heliaedu_guest_map_layer';
  }

  setCurrentMapLayer(layerType) {
    this.currentMapLayer = layerType;
    LocalStorage.setItem(this.getMapLayerKey(), layerType);
  }

  getCurrentMapLayer() {
    return this.currentMapLayer;
  }

  async getStoryDetail(id) {
    const response = await StorySource.getStoryDetail(id);
    if (!response.error) {
      this.story = response.story;
      return response.story;
    }
    throw new Error(response.message || 'Failed to get story');
  }

  isBookmarked(storyId) {
    return BookmarkService.getBookmarks().some((b) => b.storyId === storyId);
  }

  addBookmark() {
    if (!this.story) return null;
    const bookmark = BookmarkService.addBookmark(this.story);
    this.bookmarks = BookmarkService.getBookmarks();
    return bookmark;
  }

  removeBookmark(storyId) {
    const count = BookmarkService.removeBookmark(storyId);
    this.bookmarks = BookmarkService.getBookmarks();
    return count > 0;
  }

  async getLocationName(lat, lon) {
    return fetchLocationName(lat, lon);
  }

  getMapStyleConfig(isDark = false, layerType = this.currentMapLayer || 'streets') {
    return getMapStyleUrl(isDark, layerType);
  }
}
